import { useSelector } from "react-redux";


function selectPushNotifications(state) {
    return state.pushNotifications;
}

export function usePushNotifications() {
    return useSelector(selectPushNotifications);
}